import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HTTPAPI from 'i18next-http-backend';

import ACTIONS_TYPES from '../constants/types';
import store from '../store/index';
import BASE_PATH from '../constants/path';

const getSupportedLanguages = (): string[] => {
  const { globalConfig } = store.getState();
  const supportedLanguages = globalConfig.languages ?? [];
  return supportedLanguages;
};

const getFallbackLng = () => {
  const supportedLanguages = getSupportedLanguages();
  const formDefaultLanguage = store.getState().globalConfig.defaultLanguage ?? '';
  const fallbackLng = supportedLanguages.includes(formDefaultLanguage) ? formDefaultLanguage : 'en';
  return fallbackLng;
};

i18next
  .use(HTTPAPI)
  .use(initReactI18next)
  .init({
    defaultNS: 'translation',
    ns: ['translation'],
    backend: {
      loadPath: `${BASE_PATH}locales/{{lng}}/{{ns}}.json`,
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    lng: getFallbackLng(),
    // debug: true,

    react: {
      // useSuspense: false,
      wait: true,
    },
    // whitelist: getSupportedLanguages(),
    fallbackLng: getFallbackLng(),
  });

i18next.on('languageChanged', (lang) => {
  store.dispatch({
    type: ACTIONS_TYPES.SET_LANGUAGE,
    payload: getSupportedLanguages().includes(lang) ? lang : getFallbackLng(),
  });
});

export default i18next;
